<template>
	<nut-navbar
		class="navbar"
		title="上传"
		leftShow
		@on-click-back="goBack"
	></nut-navbar>
	<div class="btn-container">
		<nut-uploader
			:url="uploadUrl"
			:auto-upload="false"
			multiple
			maximum="100"
			accept="*"
			v-model:file-list="fileList"
			:before-upload="handleBeforeUpload"
			:disabled="!uploadBtnVisible"
		>
			<nut-button block type="primary" :disabled="!uploadBtnVisible">
				上传媒体
			</nut-button>
		</nut-uploader>
	</div>
	<help-text-tip @click="handleOpenDialog(UPLOAD_HELP)"></help-text-tip>
	<div class="upload-list" v-if="fileList.length">
		<div
			class="file"
			v-for="(file, index) in fileList"
			:key="file.name + index"
		>
			<span>{{ file.name }}</span>
			<span v-if="file.size">({{ getFileSize(file.size) }})</span>
			<span
				class="status"
				v-if="file.uploadStatus"
				:style="{
					color: uploadResult[file.uploadStatus].color,
				}"
				>{{ uploadResult[file.uploadStatus].text }}</span
			>
			<span
				class="status"
				v-if="file.transportResult"
				:style="{
					color: resolveResult[file.transportResult].color,
				}"
				>{{ resolveResult[file.transportResult].text }}</span
			>
			<nut-progress :percentage="file.percentage"></nut-progress>
		</div>
	</div>
	<notice-modal v-model="tipVisible" :tip="tip"></notice-modal>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { HelpTextTip } from '@/components';
import NoticeModal from '@/components/noticeModal/notice.vue';
import useDialog from '@/hooks/useDialog';
import useNavigate from '@/hooks/useNavigate';
import { uploadApi, siteApi } from '@/apis';
import { UPLOAD_HELP } from '@/constants/tiptype';
import { resolveResult, uploadResult } from '@/constants';
import { getFileSize } from '@/utils/util';

export default {
	name: 'MediaUpload',
	components: {
		HelpTextTip,
		NoticeModal,
	},
	setup() {
		const uploadUrl = ref('');
		const fileList = ref([]);
		const tipVisible = ref(false);
		const uploadBtnVisible = ref(true);
		const tip = ref(''); // 弹窗建议

		const { goBack } = useNavigate();
		const { handleOpenDialog } = useDialog();

		const getPreParams = async (params) => {
			const preParams = await uploadApi.upload_pre(params);
			return preParams;
		};

		const upload = async (file) => {
			const preParams = await getPreParams({
				file: file.name,
				size: file.size,
			});
			const { accessid, signature, policy, callback, host, key } =
				preParams || {};
			const formData = new FormData();
			formData.append('name', file.name);
			formData.append('key', key);
			formData.append('policy', policy);
			formData.append('OSSAccessKeyId', accessid);
			formData.append('success_action_status', 201);
			formData.append('callback', callback);
			formData.append('signature', signature);
			formData.append('file', file);
			const headers = { 'Content-Type': 'multipart/form-data' };

			try {
				const response = await axios({
					url: host,
					method: 'post',
					data: formData,
					timeout: 4 * 60 * 60 * 1000,
					headers,
					onUploadProgress: (progressEvent) => {
						if (progressEvent.lengthComputable) {
							var percentage = Math.ceil(
								(progressEvent.loaded / progressEvent.total) *
									100
							);
							file.percentage = percentage;
							fileList.value = [...fileList.value];
						}
					},
				});
				const result = response.data;
				// 成功
				if (result && result.id && result.mimeType) {
					file.uploadStatus = 'success';
					const data = await uploadApi.upload_done({
						id: result.id,
						file_id: preParams.file_id,
						key: result.key,
						size: result.size,
						etag: result.etag,
						mimeType: result.mimeType,
					});

					if (data.transcoding) {
						file.transportResult = 'warning';
					} else {
						file.transportResult = 'success';
					}
				} else {
					file.uploadStatus = 'fail';
				}
				fileList.value = [...fileList.value];
			} catch (error) {
				file.uploadStatus = 'fail';
				fileList.value = [...fileList.value];
				siteApi.ajax_error({
					result: error.response?.msg || error.message,
				});
			}
		};

		const handleBeforeUpload = async (files) => {
			const filesArr = [...files];
			fileList.value = [...fileList.value, ...filesArr];
			filesArr.forEach(async (file) => {
				upload(file);
			});
			return fileList.value;
		};

		const getUploadInfo = async () => {
			const data = await uploadApi.upload_load();
			uploadBtnVisible.value = data.upload;
			if (Array.isArray(data.tips) && data.tips.length) {
				tipVisible.value = true;
				tip.value = data.tips[0];
			}
		};

		const handleOk = () => {
			tipVisible.value = false;
		};

		onMounted(() => {
			getUploadInfo();
		});

		return {
			uploadUrl,
			fileList,
			resolveResult,
			uploadResult,
			UPLOAD_HELP,
			uploadBtnVisible,
			tipVisible,
			tip,
			goBack,
			handleOpenDialog,
			handleBeforeUpload,
			getFileSize,
			handleOk,
		};
	},
};
</script>
<style lang="scss" scoped>
.btn-container {
	:deep(.nut-uploader__slot) {
		width: 100%;
	}
	:deep(.nut-uploader__preview) {
		height: 0;
		margin-bottom: 0;
	}
}

.upload-list {
	padding: 15px;
	.file {
		margin-bottom: 8px;
		span {
			display: inline-block;
			margin-bottom: 10px;
			font-size: $small-font-size;
			&.status {
				margin-left: 10px;
			}
		}
	}
}
</style>
